import { useState } from 'react'
import { Box, Button, Typography, Paper, Alert, CircularProgress } from '@mui/material'
import { collection, addDoc, serverTimestamp } from 'firebase/firestore'
import { db } from '../../config/firebase'
import toast from 'react-hot-toast'

export default function SeedDatabasePage() {
    const [loading, setLoading] = useState(false)
    const [status, setStatus] = useState('')

    const handleSeed = async () => {
        try {
            setLoading(true)
            setStatus('Starting initialization...')

            // 1. Initialize Products
            setStatus('Creating sample product...')
            await addDoc(collection(db, 'products'), {
                name: 'Solar Panel 550W',
                slug: 'solar-panel-550w',
                description: 'High efficiency monocrystalline solar panel.',
                shortDescription: '550W Mono Perc Panel',
                price: 25000,
                costPrice: 20000,
                originalPrice: 28000,
                discount: 0,
                moq: 1,
                discountOnMoq: 0,
                category: { main: 'solar-panels', sub: 'monocrystalline' },
                specifications: { brand: 'Canadian Solar', model: 'CS-550', warranty: '25 years' },
                features: ['High Efficiency', 'Durable'],
                media: { images: ['https://via.placeholder.com/300'] },
                inventory: { quantity: 50, reserved: 0, available: 50 },
                seo: { metaTitle: '550W Solar Panel', metaDescription: 'Buy 550W Solar Panel', keywords: ['solar', 'energy'] },
                status: 'active',
                createdAt: serverTimestamp(),
                updatedAt: serverTimestamp()
            })

            // 2. Initialize Partners
            setStatus('Creating sample partner...')
            await addDoc(collection(db, 'partners'), {
                name: 'Main Investor',
                email: 'investor@example.com',
                phone: '03001234567',
                profitSharePercentage: 100,
                joinedAt: serverTimestamp(),
                status: 'active'
            })

            // 3. Initialize Expenses
            setStatus('Creating sample expense...')
            await addDoc(collection(db, 'expenses'), {
                type: 'rent',
                description: 'Office Rent - Jan 2026',
                amount: 50000,
                date: serverTimestamp(),
                createdAt: serverTimestamp()
            })

            // 4. Initialize Suppliers (Purchases)
            setStatus('Creating sample purchase...')
            await addDoc(collection(db, 'purchases'), {
                supplierName: 'Solar Distributors Ltd',
                invoiceNumber: 'INV-SUP-001',
                date: serverTimestamp(),
                items: [
                    {
                        productId: 'SAMPLE_ID',
                        productName: 'Solar Panel 550W',
                        category: 'solar-panels',
                        quantity: 10,
                        unitCost: 20000,
                        totalCost: 200000
                    }
                ],
                totalAmount: 200000,
                createdBy: 'admin',
                createdAt: serverTimestamp(),
                updatedAt: serverTimestamp()
            })

            // 5. Initialize Sales
            setStatus('Creating sample sale...')
            await addDoc(collection(db, 'sales'), {
                invoiceNumber: 'INV-0001',
                customerName: 'John Doe',
                customerContact: '03211234567',
                date: serverTimestamp(),
                items: [],
                totalAmount: 0,
                totalGrossProfit: 0,
                amountReceived: 0,
                outstandingAmount: 0,
                paymentMode: 'cash',
                createdBy: 'admin',
                createdAt: serverTimestamp(),
                updatedAt: serverTimestamp()
            })

            setStatus('Database initialized successfully!')
            toast.success('Database initialized!')
        } catch (error: any) {
            console.error(error)
            setStatus('Error: ' + error.message)
            toast.error('Initialization failed')
        } finally {
            setLoading(false)
        }
    }

    return (
        <Box sx={{ p: 4, maxWidth: 600, mx: 'auto' }}>
            <Paper sx={{ p: 4, textAlign: 'center' }}>
                <Typography variant="h5" gutterBottom>Database Seeder</Typography>
                <Typography variant="body2" color="text.secondary" paragraph>
                    Click the button below to create initial collections and sample data in Firestore.
                    This ensures all "tables" exist.
                </Typography>

                {status && (
                    <Alert severity={status.includes('Error') ? 'error' : 'info'} sx={{ mb: 2 }}>
                        {status}
                    </Alert>
                )}

                <Button
                    variant="contained"
                    onClick={handleSeed}
                    disabled={loading}
                    size="large"
                >
                    {loading ? <CircularProgress size={24} /> : 'Initialize Database'}
                </Button>
            </Paper>
        </Box>
    )
}
